'use client';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { HiPlusCircle } from 'react-icons/hi';

import MyTestsSummary from 'src/components/MyTestsSummary';
import NoTestsBanner from './NoTestsBanner';
import useMyTestsState from 'src/hooks/useMyTestsState';
import { testsCategoryUrl } from 'src/services/route-utils';

type Props = {
    renderFor: 'mobile' | 'desktop';
    noTestsBanner: boolean;
};

export default function TestSelection({ renderFor, noTestsBanner }: Props) {
    const { tests, loaded } = useMyTestsState();
    const [noTests, setNoTests] = useState(loaded ? !tests.length : noTestsBanner);

    useEffect(() => {
        if (loaded) {
            setNoTests(!tests.length);
        }
    }, [tests, loaded]);

    return (
        <div className={renderFor === 'mobile' ? 'pb-16 md:hidden' : undefined}>
            {noTests ? (
                <NoTestsBanner renderFor={renderFor} />
            ) : (
                <>
                    <MyTestsSummary />
                    <Link
                        className="text-primary border-dark-green/20 block border-t pt-4 hover:underline"
                        href={testsCategoryUrl(null)}>
                        <HiPlusCircle className="mr-1 inline-block text-3xl" />
                        Adaugă analize
                    </Link>
                </>
            )}
        </div>
    );
}
